import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Card, Icon, Label } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationCard extends React.PureComponent {
  render() {
    const { children, item, push, customProps, hideSidebar } = this.props

    return !item ? (
      false
    ) : (
      <Card
        fluid
        {...{
          href: item.path,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        <Icon name={item.icon} />
        <Card.Content>
          <Card.Header>
            <div
              className="ellipsis"
              children={children ? children : item.content}
            />
            {customProps && customProps.badge ? (
              <Label floating color="red">
                {customProps.badge}
              </Label>
            ) : (
              ''
            )}
          </Card.Header>
        </Card.Content>
      </Card>
    )
  }
}

NavigationCard = connect(mapStateToProps, mapDispatchToProps)(NavigationCard)
export default NavigationCard



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationCard.jsx